/**
 * product-detail custom element
 *
 * - swatch clicks render section's via Shopify section rendering API
 * - listen for addon selections and update product-form id/qty inputs for adding bundles/addons to cart
 * - @TODO: update document title on swatch change
 * - @TODO: fix selected swatch on history pops
*/

(() => {
  class ProductDetail extends HTMLElement {
    constructor() {
      super();
      this.els();
      this.settings();
      this.listeners();
    }

    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      this.variantChangeUnsubscriber = window.subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.sectionId !== this.sectionId) return;
        this.currentVariant = event.currentVariant;
        this.onVariantChange();
      });
    }

    disconnectedCallback() {
      const unsubscribers = [
        this.variantChangeUnsubscriber,
      ];

      unsubscribers.forEach(unsubscriber => unsubscriber && unsubscriber());
    }

    els() {
      this.addToCartEl = this.querySelector('[data-product-add-to-cart]');
      this.addToCartPriceEl = this.querySelector('[data-product-add-to-cart-price]');
      this.addonInputEls = this.querySelectorAll('[data-product-addon-inputs]');
      this.bundleInputEl = this.querySelector('[data-product-bundle-prop]');
      this.bundledWithInputEl = this.querySelector('[data-product-bundled-with]');
      this.sectionEl = this.closest('.shopify-section');
      this.sectionId = this.sectionEl.id.split('shopify-section-')[1];
      this.infoEl = this.querySelector(`#ProductInfo-${this.sectionId}`);
      this.mediaEl = this.querySelector('.pdp__media');
      this.pageSectionEls = this.closest('main').querySelectorAll('.shopify-section');
      this.breadcrumbsSection = document.querySelector('.shopify-section--breadcrumbs');
      this.breadcrumbsId = this.breadcrumbsSection?.id.replace('shopify-section-', '');
    }

    settings() {
      this.addonData = {
        addons: {
          selectedTotal: 0,
        },
        bundles: {
          selectedTotal: 0,
        },
      };
      this.idsToUpdate = ['pdpBadge', 'pdpGallery', 'pdpTitle', 'price', 'variantRadios', 'productForm', 'pdpAddons', 'pdpSecondary'];
      this.sectionIds = [];
      this.pageSectionEls.forEach(section => this.sectionIds.push(section.id.split('shopify-section-')[1]));
      if (this.addToCartPriceEl) this.price = parseFloat(this.addToCartPriceEl.dataset.productPrice);

      const installmentsEl = this.querySelector('#product-form-installment');
      if (!installmentsEl) return;
      this.productFormInstallment = {
        el: installmentsEl,
      }
      this.productFormInstallment.id = this.productFormInstallment.el.querySelector('[name="id"]');
      this.productFormInstallment.productId = this.productFormInstallment.el.querySelector('[name="product-id"]');
    }

    listeners() {
      subscribe(PUB_SUB_EVENTS.addonsUpdate, event => {
        this.addonData[event.type] = event;
        this.updateForm(event.data);
      });

      subscribe(PUB_SUB_EVENTS.swatchChange, event => {
        if (event.source !== 'product-detail') return;
        this.onChange(event.url);
      });

      const onHistoryChange = () => {
        const updateActiveSwatch = true;
        this.updateContent(location.href, updateActiveSwatch);
      };

      window.addEventListener('popstate', onHistoryChange);
    }

    addonSelectedIndex(id, selectedData) {
      return selectedData.findIndex(item => item.id === id);
    }

    onChange(url) {
      this.updateContent(url);
    }

    onVariantChange() {
    }

    refreshEls() {
      this.addToCartEl = this.querySelector('[data-product-add-to-cart]');
      this.addToCartPriceEl = this.querySelector('[data-product-add-to-cart-price]');
      this.addonInputEls = this.querySelectorAll('[data-product-addon-inputs]');
      this.bundleInputEl = this.querySelector('[data-product-bundle-prop]');
      this.bundledWithInputEl = this.querySelector('[data-product-bundled-with]');
      this.infoEl = this.querySelector(`#ProductInfo-${this.sectionId}`);
    }

    updateActiveSwatch(url) {
      const activeSwatchEl = this.infoEl.querySelector(`.product-swatches__item--active`);
      if (activeSwatchEl) activeSwatchEl.classList.remove('product-swatches__item--active');
      const newActiveSwatchEl = this.infoEl.querySelector(`[data-swatch-item][href="${url}"]`);
      newActiveSwatchEl && newActiveSwatchEl.classList.add('product-swatches__item--active');
    }

    updateProductFormInstallment() {
      // this.productFormInstallment.id = newId;
      // this.productFormInstallment.productId = newProductId;
    }

    updateContent(url, updateActiveSwatch = false) {
      const gallery = this.querySelector(`#pdpGallery-${this.sectionId}`);
      if (gallery) gallery.classList.add('is-loading');

      const sections = [this.sectionId];
      if (this.breadcrumbsId) sections.push(this.breadcrumbsId);
      const fetchUrl = `${url}?sections=${sections.join(',')}`;

      fetch(fetchUrl)
        .then(response => response.json())
        .then(payload => {
          // update product
          const productHtml = payload[this.sectionId];
          if (productHtml) {
            this.updateDetails(productHtml);
          }

          // update breadcrumbs
          if (this.breadcrumbsId && this.breadcrumbsSection) {
            const breadcrumbsHtml = payload[this.breadcrumbsId];
            if (breadcrumbsHtml) {
              this.breadcrumbsSection.innerHTML = breadcrumbsHtml;
            }
          }

          this.updateUrl(url);
          if (updateActiveSwatch) this.updateActiveSwatch(url);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (gallery) gallery.classList.remove('is-loading');
        });
    }

    updateDetails(html) {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const updatedProductId = parsedHtml.querySelector('[name="product-id"]')?.value || null;

      const onYou = this.querySelector('on-you');
      if (onYou) onYou.remove();

      // update content in given classes on swatch change
      const formWrapper = this.querySelector(`#productForm-${this.sectionId}`)
      const updatedForm = parsedHtml.querySelector(`#productForm-${this.sectionId}`)
      if (formWrapper && updatedForm) formWrapper.replaceWith(updatedForm);

      const variantSelect = this.querySelector(`variant-selects[data-section="${this.sectionId}"]`);
      const updatedVariants = parsedHtml.querySelector(`variant-selects[data-section="${this.sectionId}"]`);
      if (variantSelect && updatedVariants) variantSelect.replaceWith(updatedVariants);

      const variantRadios = this.querySelector(`#variantRadios-${this.sectionId}`);
      const updatedRadios = parsedHtml.querySelector(`#variantRadios-${this.sectionId}`);
      if (variantRadios && updatedRadios) variantRadios.replaceWith(updatedRadios);

      const currentMediaCard = this.querySelector('.pdp-info__container .media-card');
      const newMediaCard = parsedHtml.querySelector('.pdp-info__container .media-card');
      if (currentMediaCard && newMediaCard) {
        currentMediaCard.replaceWith(newMediaCard);
      }

      const currentCarousel = this.querySelector('.shopify-block--product-upsell-carousel');
      const newCarousel = parsedHtml.querySelector('.shopify-block--product-upsell-carousel');
      if (currentCarousel && newCarousel) {
        currentCarousel.replaceWith(newCarousel);
      }

      const currentProductModal = this.querySelector(`#ProductModal-${this.sectionId}`);
      const newProductModal = parsedHtml.querySelector(`#ProductModal-${this.sectionId}`);
      if (currentProductModal && newProductModal) currentProductModal.replaceWith(newProductModal);

      const currentDescription = this.querySelector('.pdp__accordion-content--description');
      const newDescription = parsedHtml.querySelector('.pdp__accordion-content--description');
      if (currentDescription && newDescription) {
        currentDescription.replaceWith(newDescription);
      }

      const currentModelInfo = this.querySelector('.pdp__accordion-content--model-details');
      const newModelDetails = parsedHtml.querySelector('.pdp__accordion-content--model-details');
      if (currentModelInfo && newModelDetails) {
        currentModelInfo.replaceWith(newModelDetails);
      }

      const shareLinks = this.querySelector('.pdp__accordion-content--share');
      const newShareLinks = parsedHtml.querySelector('.pdp__accordion-content--share');
      if (shareLinks && newShareLinks) {
        shareLinks.replaceWith(newShareLinks);
      }

      const notifyBtn = this.querySelector('#pdpNotifyBtn');
      const newNotifyBtn = parsedHtml.querySelector('#pdpNotifyBtn');
      if (notifyBtn && newNotifyBtn) {
        notifyBtn.replaceWith(newNotifyBtn);
      }


      const notifyPopUp = this.querySelector('#bisPopUp');
      const newNotifyPopUp = parsedHtml.querySelector('#bisPopUp');
      if (notifyPopUp && newNotifyPopUp) {
        notifyPopUp.replaceWith(newNotifyPopUp);
      }

      this.idsToUpdate.forEach(id => {
        const elId = `${id}-${this.sectionId}`;
        const el = this.querySelector(`#${elId}`);
        const parsedEl = parsedHtml.querySelector(`#${elId}`);
        if (el && parsedEl) {
          el.innerHTML = parsedEl.innerHTML;
        }
      });

      if (onYou && updatedProductId) {
        onYou.dataset.productId = updatedProductId;
      }

      if (onYou) {
        const slot = this.querySelector('[data-on-you-slot]');
        if (slot) {
          slot.replaceWith(onYou);
        } else {
          this.appendChild(onYou);
        }
      }

      this.refreshEls()
      requestAnimationFrame(() => {
        window.swipers && window.swipers();
        window.inView && window.inView();
      });
    }

    updateAddToCartButton() {
      if (!this.addToCartPriceEl) return;
      this.addToCartPriceEl = this.querySelector('[data-product-add-to-cart-price]');
      this.addToCartPriceEl.innerHTML = window.Shopify.formatMoney(this.price + this.addonData.addons.selectedTotal + this.addonData.bundles.selectedTotal).replace('.00', '');
    }

    updateForm(addonsData) {
      const bundleId = Date.now();

      Object.values(addonsData).forEach(item => {
        if (!item || !item.hasOwnProperty('id')) return;
        const el = this.querySelector(`[data-product-addon-inputs="${item.id}"]`);
        const quantityInput = el.querySelector('[data-addon-quantity-input]');
        const idInput = el.querySelector('[data-addon-id-input]');
        const bundleInput = el.querySelector('[data-addon-bundle-input]');
        const bundledWithInput = el.querySelector('[data-addon-bundled-with-input]');

        if (item.isSelected) {
          // if selected add name attribute
          idInput.setAttribute('name', idInput.dataset.name);
          quantityInput.setAttribute('name', quantityInput.dataset.name);

          // add _bundle_id prop to main product and bundled product
          if (bundleInput) {
            bundleInput.setAttribute('name', bundleInput.dataset.name);
            bundleInput.value = bundleId;
            bundledWithInput.setAttribute('name', bundledWithInput.dataset.name);
            this.bundleInputEl.setAttribute('name', this.bundleInputEl.dataset.name);
            this.bundleInputEl.value = bundleId;
            this.bundledWithInputEl.setAttribute('name', this.bundledWithInputEl.dataset.name);
          }

          quantityInput.value = item.quantity;
        } else {
          // if not selected remove name attribute
          idInput.removeAttribute('name');
          quantityInput.removeAttribute('name');
          if (bundleInput) {
            bundleInput.removeAttribute('name');
            bundleInput.removeAttribute('name');
            bundledWithInput.removeAttribute('name');
          }
        }
      });

      // remove _bundle_id_id prop from main product if no bundled products are selected
      const bundledItem = this.querySelector('[name][data-addon-bundle-input]');
      if (!bundledItem) {
        if (this.bundleInputEl) this.bundleInputEl.removeAttribute('name');
        if (this.bundledWithInputEl) this.bundledWithInputEl.removeAttribute('name');
      } else {
        if (this.bundledWithInputEl) this.bundledWithInputEl.value = bundledItem.dataset.title;
      }

      this.updateAddToCartButton(addonsData);
    }

    updateUrl(url) {
      window.history.pushState({}, '', url)
    }
  }

  if (!customElements.get('product-detail')) {
    customElements.define('product-detail', ProductDetail);
  }
})();
